export default __webpack_public_path__ + "static/scores-3630677cad79f581710b8f2245d5f0b6.webp";